import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import esTranslation from 'src/assets/translations/es.json';
import { BaseService } from './base.service';

@Component({
  template: '',
})
export abstract class BaseComponent implements OnInit, OnDestroy {
  readonly screen: any = esTranslation;
  protected subscriptions: Subscription[] = [];
  protected setScreen = false;
  loading = false;
  loadingIcon = 'fas fa-circle-notch fa-spin';
  pageSize = 20;
  today = new Date();
  saving = false;

  constructor(protected store?: Store<any>, protected service?: BaseService) {}

  ngOnInit(): void {
    if (this.service) {
      this.subscriptions.push(
        this.service
          .getLoadingState()
          .subscribe((loading) => setTimeout(() => (this.loading = loading)))
      );
      if (this.setScreen) {
        this.service.setScreenInformation({
          id: this.screen.id,
          title: this.screen.title,
        });
      }
    }
    this.onInit();
  }

  protected onInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.onDestroy();
  }

  protected onDestroy(): void {}
}
